import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Abbas from '../../img/agenda/Abbas.png'
import Barroso from '../../img/agenda/Barroso.png'
import Lin from '../../img/agenda/Lin.png'
import Manichord from '../../img/agenda/Manichord Pty Ltd.png'
import Pvotal from '../../img/agenda/Pvotal.png'
import reactree from '../../img/agenda/reactree.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '10:10',
                  photo: Abbas,
                  name: 'Sakina Abbas',
                  position: 'Co-founder & CEO',
                  ln: 'https://pk.linkedin.com/in/sakina-abbas',
                  tw: 'https://twitter.com/sakin8tor',
                  github: 'https://github.com/sakina-abbas',
                  logo: reactree,
                  title: 'Power up your Flutter app with Google Actions!',
                  abstract: `Do you want to interact with your Android Flutter app but got your hands full? Maybe you're driving or are just busy in the kitchen.
                  Well, it's time to leverage Google Actions and make your app accessible by voice!
                  In this session, you'll learn what Google Assistant is, explore different types of Actions that are available by default and then integrate them in your Flutter (Android) app.
                  In the end, we will also see a working demo of an Android app built with Flutter - that we try to access via Google Assistant!`,
              },
              {
                  id: 2,
                  time: '10:50',
                  photo: Lin,
                  name: 'Maksim Lin',
                  position: 'Software Engineer, GDE',
                  tw: 'https://twitter.com/mklin',
                  logo: Manichord,
                  title: 'Finally! Dart gets a REPL',
                  abstract: `I will cover the Dart REPL package that I have recently published and continue to work on. I will go over the history of REPLs in Dart, the difficulties in implementing a REPL for Dart, including some examples of code used to implement that REPL, as well as demonstrate the current features of the REPL package I have built.`,
              },
              {
                  id: 3,
                  time: '11:30',
                  photo: Barroso,
                  name: 'Filipe Barroso',
                  position: 'Senior Flutter Developer',
                  ln: 'https://www.linkedin.com/in/filipeabarroso/',
                  tw: 'https://twitter.com/ABarroso',
                  github: 'https://github.com/Oldmetalmind',
                  logo: Pvotal,
                  title: 'Dart Microservice with Google Cloud Platform',
                  abstract: `We all know the power of Flutter, but you can't forget that with great power comes ... Dart! The super-powered programming language is also quite good in the backend too. With this talk I'll present the reason why I picked Dart for a backed project, I'll show you how to build an API with Shelf deploying it at Google Cloud Platform to use with Google Build, Run, Scheduler, Storage, Container Registry, Source Repository and Pub/Sub! Just to name a few.`,
              },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">June 1 10:00 - 19:00</p>
                    <p className="agenda_day">Junior Track</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/flutter22' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};